import React from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  centered = true,
  className = '',
}) => {
  return (
    <div className={`mb-12 ${centered ? 'text-center' : ''} ${className}`}>
      <h2 className="font-abadi text-3xl md:text-4xl font-light mb-4">
        {title}
      </h2>
      {subtitle && (
        <p className="text-dark-gray max-w-2xl mx-auto text-lg">
          {subtitle}
        </p>
      )}
      <div className={`h-1 w-16 bg-secondary mt-4 ${centered ? 'mx-auto' : ''}`}></div>
    </div>
  );
};

export default SectionHeading;